import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination} from "swiper/modules";
import React, {useEffect, useRef, useState} from "react";
import {combineClassNames, getMediaPath} from "../../app/functions";
import './index.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import arrow_gallery from "../../assets/icons/arrow-gallery.svg";
import {useSelector} from "react-redux";

const ImageCarousel = ({tagImage, imgs = [], className = '', loop = false, overlay}) => {
    const swiperRef = useRef();

    const [selectedImage, setSelectedImage] = useState();
    const [activeIndex, setActiveIndex] = useState(0);

    const notMobile = useSelector(store => store.state.deviceState) !== 'mobile';

    useEffect(() => {
        if (imgs.length > 0) {
            setSelectedImage(imgs[0].src);
        }
    }, [imgs])

    const onSwiperInit = (swiper) => {
        swiperRef.current = swiper;
    };

    const swiperOptions = {
        onSwiper: onSwiperInit,
        dir: 'ltr',
        modules: [Pagination],
        pagination: {
            clickable: true,
            enabled: true
        },
        loop,
        breakpoints: {
            320: {
                direction: 'horizontal',
                slidesPerView: 1,
            },
            768: {
                direction: 'vertical',
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1200: {
                direction: 'vertical',
                slidesPerView: 4,
                spaceBetween: 30,
            },
            1500: {
                direction: 'vertical',
                slidesPerView: 4,
                spaceBetween: 30,
            },
        }
    };

    const slideToImage = (idx) => {
        if (idx > imgs.length - 1) {
            idx = 0;
        }
        if (idx < 0) {
            idx = imgs.length - 1;
        }
        if (swiperRef.current) {
            swiperRef.current.slideTo(idx);
            setActiveIndex(idx);
        }
    };

    const showSlider = !notMobile || (notMobile && imgs.length > 1);
    const showSliderClass = showSlider ? 'slider' : '';

    return (
        <div className={combineClassNames('carousel-wrapper', showSliderClass, className)}>
            {overlay && (
                <div className="carousel-favorite-slot carousel-favorite-slot--mobile">
                    {React.cloneElement(overlay, {key: 'carousel-favorite-mobile'})}
                </div>
            )}
            {showSlider && (
                <Swiper {...swiperOptions}>
                    {imgs.map((img, idx) => (
                        <SwiperSlide
                            key={`carousel-img-${idx}`}
                            onClick={slideToImage.bind(this, idx)}
                            className={activeIndex === idx ? 'selected' : ''}
                        >
                            {tagImage && <img src={tagImage} id={"swiper-tag-image"} className={'tag-image'}/>}
                            {img.component}
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
            <div className="selected-image-wrapper">
                {overlay && (
                    <div className="carousel-favorite-slot carousel-favorite-slot--desktop">
                        {React.cloneElement(overlay, {key: 'carousel-favorite-desktop'})}
                    </div>
                )}
                {imgs[activeIndex].iframe ? (
                    <>
                        <iframe src={imgs[activeIndex].iframe} className="selected-image" referrerPolicy="strict-origin-when-cross-origin"/>
                        {tagImage && <img src={tagImage} className={'tag-image'}/>}
                    </>
                ) : (
                    <>
                        <img src={imgs[activeIndex].src} alt="" className="selected-image"/>
                        {tagImage && <img src={tagImage} className={'tag-image'}/>}
                    </>
                )}
                {imgs.length > 1 && (
                    <>
                        <SliderArrow onClick={slideToImage.bind(this, activeIndex + 1)}/>
                        <SliderArrow onClick={slideToImage.bind(this, activeIndex - 1)} className={'back'}/>
                    </>
                )}
            </div>
        </div>
    );
};

export default ImageCarousel;

function SliderArrow(props) {
    const {onClick, className = ''} = props;
    return (
        <div className={combineClassNames('slider-arrow', className)} onClick={onClick}>
            <img src={getMediaPath(arrow_gallery)} alt=""/>
        </div>
    );
}
